import { IBooleanCondition } from '../../../../inputs/expressions-editor/conditions/IBooleanCondition';

export enum CustomWarningRuleType {
  Warning = 'warning',
  Error = 'error',
}

export interface ICustomWarningRule {
  type: CustomWarningRuleType;
  message: string;
  condition: IBooleanCondition;
}
